// Accordion JS is now handled by blocks/accordion/scripts.js (vanilla, enqueued per-block).

// NB: the mobile hamburger is owned by Bootstrap's collapse plugin
// (data-bs-toggle on .site-nav-toggle — see mega-menu.js). A second handler
// here used to also flip aria-expanded, which fought Bootstrap and left the
// hamburger/close icon stuck in the wrong state. Removed.

// ==========================
// HOMEPAGE BLOCKS
// ==========================

(function () {

  // ==========================
  // HERO CARDS
  // ==========================

  function initHeroCards() {
  	if (window.innerWidth < 992) return;
    const cards = document.querySelectorAll(".hero-card");
    if (cards.length < 2) return;

    let active = document.querySelector(".hero-card.is-active") || cards[0];
    active.classList.add("is-active");

    cards.forEach(card => {
      card.addEventListener("mouseenter", () => {
        if (card === active) return;
        active.classList.remove("is-active");
        card.classList.add("is-active");
        active = card;
      });
    });
  }

  // ==========================
  // HERO HEADLINES
  //
  // Binary-searches an inline font-size that keeps the headline on one line,
  // capped at the CSS ramp's own size so short copy never grows past its
  // designed size (it can only shrink to avoid wrapping). Below 768px the
  // inline size is cleared and the CSS ramp, which allows wrapping, applies.
  // ==========================

  // `el.scrollWidth` reports the `text-wrap: balance` line-box's established
  // width, not whether the (SplitType, inline-block-per-word) text actually
  // wrapped — so wrapping is detected by comparing each word's own `top`.
  function measureWidth(el) {
      const words = el.querySelectorAll(".word-wrapper");
      if (!words.length) {
          return el.scrollWidth;
      }
      let left = Infinity, right = -Infinity, top = null, wrapped = false;
      words.forEach((w) => {
          const r = w.getBoundingClientRect();
          if (top === null) {
              top = r.top;
          } else if (Math.abs(r.top - top) > 1) {
              wrapped = true;
          }
          left = Math.min(left, r.left);
          right = Math.max(right, r.right);
      });
      return wrapped ? Infinity : right - left;
  }

  function fitHeadline(el) {
      el.style.fontSize = "";
      const rampSize = parseFloat(getComputedStyle(el).fontSize);
      let min = 20, max = rampSize;

      const parent = el.parentElement;
      const parentStyle = getComputedStyle(parent);
      const w = parent.clientWidth - parseFloat(parentStyle.paddingLeft) - parseFloat(parentStyle.paddingRight);

      el.style.fontSize = rampSize + "px";
      if (measureWidth(el) <= w) {
          return;
      }

      while (min <= max) {
          const mid = (min + max) / 2;
          el.style.fontSize = mid + "px";
          measureWidth(el) > w ? max = mid - 1 : min = mid + 1;
      }
      el.style.fontSize = max + "px";
  }

  function initHeroHeadlines() {
      const mobile = window.innerWidth < 768;
      document.querySelectorAll(".hero-display, .fit-text").forEach(el => {
          if (mobile) {
              el.style.fontSize = "";
          } else {
              fitHeadline(el);
          }
      });
  }

  let heroHeadlineResizeTimer;
  window.addEventListener("resize", () => {
      clearTimeout(heroHeadlineResizeTimer);
      heroHeadlineResizeTimer = setTimeout(initHeroHeadlines, 150);
  });

  window.addEventListener("load", initHeroHeadlines);

/**
 * Stats Scroller — GSAP ScrollTrigger
 */

function initStatsScroller() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  if (window.innerWidth < 768) return;

  // Reduced-motion: skip the pin/scrub/parallax entirely and let the
  // slides render as a plain stack (see the matching CSS fallback in
  // _stats-scroller.scss) instead of scroll-jacking the page. This section's
  // headline/mask reveal classes (.split-text-element-*, .mask-in-up) are
  // normally only ever un-hidden by activateSlide()'s window.revealSection()
  // call as GSAP advances each slide — since that never runs here, force
  // them visible directly instead of relying on the animation engine's
  // class toggles (which need SplitType/buildRegistry to have already run),
  // or their content (opacity:0 / translated off-screen by default, see
  // _animations.scss) would stay permanently invisible.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var staticSection = document.querySelector('.stats-scroller');
    if (staticSection) {
      staticSection.querySelectorAll(
        '.split-text-element-s, .split-text-element-m, .split-text-element-f, .mask-in-up'
      ).forEach(function (el) {
        el.style.opacity = '1';
        el.style.translate = '0 0';
      });
    }
    return;
  }

  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.config({ ignoreMobileResize: true });

  if ('ontouchstart' in window) {
    ScrollTrigger.normalizeScroll(true);
  }

  // ─────────────────────────────────────────────────────────────
  // ELEMENTS
  // ─────────────────────────────────────────────────────────────

  const section = document.querySelector('.stats-scroller');
  const pin     = document.querySelector('.stats-pin');
  const track   = document.querySelector('.stats-track');
  const slides  = gsap.utils.toArray('.stats-slide');

  if (!section || !pin || !track || !slides.length) return;

  const slideCount    = slides.length;
  const getScrollDist = () => (slideCount - 1) * window.innerHeight;

  let currentSlide = -1;

  // ─────────────────────────────────────────────────────────────
  // PIN BACKGROUND
  // ─────────────────────────────────────────────────────────────

  ScrollTrigger.create({
    trigger    : section,
    start      : 'top top',
    end        : () => '+=' + getScrollDist(),
    pin        : '.stats-bg',
    pinSpacing : false,
  });

  // ─────────────────────────────────────────────────────────────
  // MASTER PIN + SCROLL DRIVER
  // ─────────────────────────────────────────────────────────────

  ScrollTrigger.create({
    trigger : section,
    start   : 'top top',
    end     : () => '+=' + getScrollDist(),
    pin     : pin,
    scrub   : 0.8,

    onUpdate(self) {
      const p  = self.progress;
      const sd = getScrollDist();

      // ── Move the track ──────────────────────────────────────
      gsap.set(track, { y: -(sd * p) });

      // ── Per-slide parallax ──────────────────────────────────
      slides.forEach((slide, i) => {
        const sp = p * slideCount - i; // 0 = slide enters, 1 = next enters
        if (sp > -0.5 && sp < 1.5) applyParallax(slide, sp);
      });

      // ── Slide activation (counters / reveals only) ──────────
      // REVEAL_LEAD fires each slide's reveal a fraction of a slide-window
      // early, so text/images animate in as the slide arrives rather than
      // after it has settled (the section's scrub otherwise makes it feel
      // delayed). 0 = on the slide boundary; higher = earlier. Tune to taste.
      const REVEAL_LEAD = 0.4;
      const idx = Math.min(slideCount - 1, Math.floor(p * slideCount + REVEAL_LEAD));
      if (idx !== currentSlide) {
        currentSlide = idx;
        activateSlide(slides[idx]);
      }
    },
  });

  // ─────────────────────────────────────────────────────────────
  // PARALLAX
  // ─────────────────────────────────────────────────────────────

  function applyParallax(slide, sp) {

    // ── Column 0 (left) — slow ───────────────────────────────
    // slide-1: .stats-image   slide-2: .stats-graphic
    // slide-3: .stats-text    slide-4: .stat-primary
    const col0 = slide.children[0];
    if (col0) gsap.set(col0, { y: sp * -20 });

    // ── Column 1 (right) — fast ──────────────────────────────
    // slide-1: .stats-text    slide-2: .stats-image
    // slide-3: .stats-image   slide-4: .stat-image
    const col1 = slide.children[1];
    if (col1) gsap.set(col1, { y: sp * -85 });

    // ── Percentage badges ─────────────────────────────────────
    //   Slide 1 (badge in col0): page movement = sp×(-20 − 75) − 40
    //   Slide 3 (badge in col1): page movement = sp×(-85 − 75) − 40
    slide.querySelectorAll('.stats-percentage').forEach(el => {
      gsap.set(el, { y: sp * -75 - 60 });
    });

    // ── Slide 4 overlay number ────────────────────────────────
    const overlayNum = slide.querySelector('.stat-overlay .num');
    if (overlayNum) gsap.set(overlayNum, { y: sp * -75 - 40 });

    // ── Texture background-position ───────────────────────────
    slide.querySelectorAll('.has-texture').forEach(el => {
      gsap.set(el, {
        backgroundPosition: `${50 + sp * 6}% ${50 + sp * 12}%`,
      });
    });
  }

  // ─────────────────────────────────────────────────────────────
  // SLIDE ACTIVATION
  // ─────────────────────────────────────────────────────────────

  function activateSlide(slide) {
    if (!slide) return;

    // ── Scroll-reveal (split text / masks) — driven here so it stays in sync
    //    with GSAP moving each slide into view, not with page scroll. ────────
    if (window.revealSection) window.revealSection(slide);

    // ── Slide 2: SVG path fill reveal ─────────────────────────
    if (slide.classList.contains('slide-2')) {
      const path = slide.querySelector('svg path');
      if (path && !path.dataset.done) {
        gsap.fromTo(path,
          { fillOpacity: 0.05 },
          { fillOpacity: 1, duration: 1.6, ease: 'power2.out' }
        );
        path.dataset.done = 'true';
      }
    }
  }

  // ─────────────────────────────────────────────────────────────
  // BOOT: fire first slide's one-shots immediately
  // ─────────────────────────────────────────────────────────────

  // Reveal the first (headline) slide when the section scrolls into view.
  // Its reveal can't ride the idx-change activation below (idx stays 0 until
  // you scroll to slide 1), and at boot window.revealSection isn't defined yet.
  ScrollTrigger.create({
    trigger: section,
    start: 'top 85%',
    once: true,
    onEnter() { if (window.revealSection) window.revealSection(slides[0]); },
  });

  activateSlide(slides[0]);
  currentSlide = 0;
}


function initPanelSlider() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

    if (window.innerWidth < 992) return;

    // Reduced-motion: bail before setInitialStates() ever runs, so panel
    // content is never hidden (autoAlpha:0) in the first place — nothing
    // else needs to reveal it, unlike stats-scroller's reveal-class markup.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    gsap.registerPlugin(ScrollTrigger);

    const section  = document.querySelector(".panel-scroller");
    const track    = document.querySelector(".panel-track");
    const slides   = document.querySelectorAll(".panel-slide");
    const dots     = document.querySelectorAll(".panel-dot");
    const bar      = document.querySelector(".panel-progress-bar");
    const progressEl = document.querySelector(".panel-progress");

    if (!section || !track || !slides.length) return;

    const numSlides      = slides.length;
    const isMobile       = () => window.innerWidth < 992;
    const slideWidth     = () => window.innerWidth;
    const totalTravel    = () => (numSlides - 1) * slideWidth();
    const animated       = new Set();
    let current          = -1;
    let mobileTicking    = false;
    let activeInstances  = []; // ScrollTrigger instances to kill on reinit
    let activeST = null;

    // --------------------------------------------------
    // INITIAL STATES
    // --------------------------------------------------

    function setInitialStates() {
        slides.forEach(slide => {
            const headline = slide.querySelector(".panel-headline");
            const img      = slide.querySelector(".panel-image-wrap img");
            const learn    = slide.querySelector(".panel-learn");

            if (headline) gsap.set(headline, { x: -50, autoAlpha: 0 });
            if (img)      gsap.set(img,      { y: 20,  autoAlpha: 0 });

            if (learn) {
                if (isMobile()) {
                    gsap.set(learn, { x: 40, autoAlpha: 0 });
                } else {
                    // yPercent: -50 replaces the CSS transform: translateY(-50%)
                    // that was intentionally removed from .panel-learn in SCSS.
                    gsap.set(learn, { yPercent: -50, x: 50, autoAlpha: 0 });
                }
            }
        });
    }

    // --------------------------------------------------
    // ENTRANCE ANIMATION — plays once per slide per load
    // --------------------------------------------------

    function animateIn(index) {
        if (animated.has(index)) return;
        animated.add(index);

        const slide    = slides[index];
        const headline = slide.querySelector(".panel-headline");
        const img      = slide.querySelector(".panel-image-wrap img");
        const learn    = slide.querySelector(".panel-learn");

        const tl = gsap.timeline();

        if (headline) {
            tl.to(headline, { x: 0, autoAlpha: 1, duration: 0.75, ease: "power3.out" }, 0.08);
        }
        if (img) {
            tl.to(img, { y: 0, autoAlpha: 1, duration: 0.85, ease: "power2.out" }, 0.15);
        }
        if (learn) {
            // yPercent is left untouched — only x and opacity animate.
            tl.to(learn, { x: 0, autoAlpha: 1, duration: 0.75, ease: "power3.out" }, 0.25);
        }
    }

    // --------------------------------------------------
    // UPDATE UI — shared by desktop (via ST onUpdate) and mobile (via scroll event)
    // --------------------------------------------------

    function updateUI(progress) {
        if (bar) gsap.set(bar, { width: (progress * 100) + "%" });
        if (progressEl) progressEl.setAttribute("aria-valuenow", Math.round(progress * 100));

        const newIndex = Math.min(Math.round(progress * (numSlides - 1)), numSlides - 1);

        if (newIndex !== current) {
            current = newIndex;
            dots.forEach((dot, i) => {
                dot.classList.toggle("is-active", i === current);
            });
            animateIn(current);
        }
    }

    // --------------------------------------------------
    // DESKTOP — ScrollTrigger pin + scrub
    // --------------------------------------------------

    function initDesktop() {
	    activeInstances.forEach(st => st.kill());
	    activeInstances = [];
	    gsap.set(track, { clearProps: "x,transform" });

	    const dwellRatio      = 0.15;
	    const dwellDistance   = totalTravel() * dwellRatio;
	    const totalPinDist    = dwellDistance + totalTravel() + dwellDistance;

	    const tl = gsap.timeline();

	    // Start dwell — nothing moves
	    tl.to({}, { duration: dwellRatio });

	    // Track animation — starts at t = dwellRatio
	    tl.to(track, {
	        x: () => -totalTravel(),
	        ease: "none",
	        duration: 1,
	    }, dwellRatio);

	    // Parallax on each bg — same window as track
	    const parallaxFactor = 0.1;
	    slides.forEach((slide, i) => {
	        const bg = slide.querySelector(".panel-bg");
	        if (!bg) return;

	        const fromX = -i * slideWidth() * parallaxFactor;
	        const toX   = (numSlides - 1 - i) * slideWidth() * parallaxFactor;

	        gsap.set(bg, { x: fromX });
	        tl.to(bg, { x: toX, ease: "none", duration: 1 }, dwellRatio);
	    });

	    // End dwell — nothing moves
	    tl.to({}, { duration: dwellRatio }, dwellRatio + 1);

	    // Single ScrollTrigger drives the whole timeline
	    const totalTlDur = 1 + dwellRatio * 2;

	    const st = ScrollTrigger.create({
	        animation: tl,
	        trigger: section,
	        start: "top top",
	        end: () => `+=${totalPinDist}`,
	        pin: true,
	        anticipatePin: 1,
	        scrub: 1,
	        invalidateOnRefresh: true,
	        onUpdate: self => {

	            const rawPos       = self.progress * totalTlDur;
	            const slideProgress = Math.max(0, Math.min(1, (rawPos - dwellRatio) / 1));
	            updateUI(slideProgress);
	        },
	    });

	    activeInstances.push(st);
	    activeST = st;
	}

    // --------------------------------------------------
    // MOBILE — native scroll-snap + lightweight event listener
    // --------------------------------------------------

    function initMobile() {
        // Kill all desktop ScrollTrigger instances
        activeInstances.forEach(st => st.kill());
        activeInstances = [];

        // Clear any GSAP x leftover from desktop
        gsap.set(track, { clearProps: "x,transform" });
        slides.forEach(slide => {
            const bg = slide.querySelector(".panel-bg");
            if (bg) gsap.set(bg, { clearProps: "x,transform" });
        });

        track.addEventListener("scroll", onMobileScroll, { passive: true });
    }

    function onMobileScroll() {
        if (!mobileTicking) {
            requestAnimationFrame(() => {
                const scrollLeft = track.scrollLeft;
                const maxScroll  = track.scrollWidth - track.clientWidth;
                const progress   = maxScroll > 0 ? scrollLeft / maxScroll : 0;
                updateUI(progress);
                mobileTicking = false;
            });
            mobileTicking = true;
        }
    }

    // --------------------------------------------------
    // DOT NAVIGATION
    // --------------------------------------------------

		dots.forEach((dot, i) => {
	    dot.addEventListener("click", (e) => {
	        e.preventDefault();

	        if (isMobile()) {
	            track.scrollTo({ left: i * track.clientWidth, behavior: "smooth" });
	            return;
	        }

	        if (!activeST) return;

	        const dwellRatio  = 0.15;
	        const totalTlDur  = 1 + dwellRatio * 2;
	        const slideProgress = numSlides > 1 ? i / (numSlides - 1) : 0;
	        const stProgress  = (slideProgress + dwellRatio) / totalTlDur;

	        const targetScroll = activeST.start + stProgress * (activeST.end - activeST.start);

	        window.scrollTo({ top: targetScroll, behavior: "smooth" });
	    });
	});

    // --------------------------------------------------
    // RESIZE — reinit for breakpoint switches
    // --------------------------------------------------

    let resizeTimer;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            animated.clear();
            current = -1;
            setInitialStates();

            if (isMobile()) {
                initMobile();
                updateUI(0);
            } else {
                // ScrollTrigger.refresh() recalculates pin distances after resize
                initDesktop();
                ScrollTrigger.refresh();
            }
        }, 250);
    });

    // --------------------------------------------------
    // INIT
    // --------------------------------------------------

    setInitialStates();

    if (isMobile()) {
        initMobile();
        updateUI(0); // prime first slide immediately
    } else {
        initDesktop();
        updateUI(0);
    }
}


// ==========================
// STORIES SLIDER
// ==========================

function initStoriesSlider() {

  if (typeof gsap === "undefined") return;

  const slider = document.querySelector(".stories-slider");
  if (!slider) return;

  const slides = slider.querySelectorAll(".story-slide");
  // .story-dot is duplicated inside every .story-col-image (one copy per
  // slide, so the ticks always sit within that slide's own texture box) —
  // sync by their shared data-index, not NodeList position.
  const dots = slider.querySelectorAll(".story-dot");
  const nextBtn = slider.querySelector(".story-next");
  const prevBtn = slider.querySelector(".story-prev");

  if (!slides.length) return;

  let current = 0;
  let isAnimating = false;

  // Reduced-motion: still a real click-driven carousel (not scroll-jacked),
  // so keep prev/next/dots working — just skip the GSAP entrance sweep and
  // switch slides instantly via the existing .is-active CSS rule instead.
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  gsap.set(slides, { autoAlpha: 0 });

  // --------------------------
  // ANIMATE IN (REUSABLE)
  // --------------------------

  function animateIn(slide, dir = 1) {

    const image = slide.querySelector(".story-image-wrap");
    const text = slide.querySelector(".story-content");

    gsap.set(slide, { autoAlpha: 1 });

    // Replay the split-text word reveal for the slide being shown.
    if (window.retriggerSplitText) window.retriggerSplitText(slide);

    if (REDUCED) {
      if (image) gsap.set(image, { autoAlpha: 1 });
      if (text) gsap.set(text, { x: 0, autoAlpha: 1 });
      return;
    }

    const tl = gsap.timeline();

    if (image) {
      tl.fromTo(image,
        { autoAlpha: 0 },
        { autoAlpha: 1, duration: 0.5 },
        0.2
      );
    }

    if (text) {
      tl.fromTo(text,
        { x: 60 * dir, autoAlpha: 0 },
        { x: 0, autoAlpha: 1, duration: 0.6 },
        0.3
      );
    }
  }

  // --------------------------
  // SLIDE CHANGE
  // --------------------------

  function goTo(index, dir = 1) {

    if (isAnimating || index === current) return;

    slides.forEach((s, i) => s.classList.toggle("is-active", i === index));

    const currentSlide = slides[current];
    const nextSlide = slides[index];

    if (REDUCED) {
      gsap.set(currentSlide, { autoAlpha: 0 });
      animateIn(nextSlide, dir);
      current = index;
    } else {
      isAnimating = true;

      const tl = gsap.timeline({
        onComplete: () => {
          current = index;
          isAnimating = false;
        }
      });

      tl.to(currentSlide, { autoAlpha: 0, duration: 0.3 }, 0);

      animateIn(nextSlide, dir);
    }

    dots.forEach((d) => {
      d.classList.toggle("is-active", Number(d.dataset.index) === index);
    });
  }

  // --------------------------
  // NAV
  // --------------------------

  function next() {
    goTo((current + 1) % slides.length, 1);
  }

  function prev() {
    goTo((current - 1 + slides.length) % slides.length, -1);
  }

  if (nextBtn) nextBtn.addEventListener("click", next);
  if (prevBtn) prevBtn.addEventListener("click", prev);

  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      const i = Number(dot.dataset.index);
      goTo(i, i > current ? 1 : -1);
    });
  });

  // --------------------------
  // INIT (CRITICAL FIX)
  // --------------------------

  animateIn(slides[0], 1);

  // The section-level headline sits inside .stories-slider (DRIVEN in
  // animations.js, so the generic scroll observer skips it) but isn't tied
  // to any slide's activation — nothing else ever reveals it. Same one-shot
  // boot pattern as stats-scroller's first-slide reveal.
  const headline = slider.querySelector(".section-headline");
  if (headline && typeof ScrollTrigger !== "undefined") {
    ScrollTrigger.create({
      trigger: slider,
      start: "top 85%",
      once: true,
      onEnter() { if (window.revealSection) window.revealSection(headline); },
    });
  }
}

  // ==========================
  // MEDIA SLIDER
  // ==========================

	function initMediaSlider() {
	  const slides = document.querySelectorAll(".media-slide");
	  if (!slides.length) return;

	  const thumbs = document.querySelectorAll(".media-thumb");
	  const bar = document.querySelector(".media-progress-bar");
	  const pauseBtn = document.querySelector("[data-media-pause]");
	  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	  let current = 0;
	  let interval;
	  let paused = false;
	  const duration = 5000;

	  function goTo(i) {
	    slides.forEach((s, idx) => s.classList.toggle("is-active", idx === i));
	    thumbs.forEach((t, idx) => {
	      t.classList.toggle("is-active", idx === i);
	      t.setAttribute("aria-pressed", idx === i ? "true" : "false");
	    });
	    current = i;
	    // Reveal this slide's caption / image the first time it's shown.
	    if (window.revealSection) window.revealSection(slides[i]);
	    reset();
	  }

	  function start() {
	    clearInterval(interval);
	    if (paused) return;
	    interval = setInterval(() => goTo((current + 1) % slides.length), duration);
	    animate();
	  }

	  function stop() {
	    clearInterval(interval);
	    if (bar) {
	      bar.style.transition = "none";
	      bar.style.transform = "scaleY(0)";
	    }
	  }

	  function animate() {
	    if (!bar || paused) return;

	    bar.style.transition = "none";
	    bar.style.transform = "scaleY(0)";

	    requestAnimationFrame(() => {
	      requestAnimationFrame(() => {
	        bar.style.transition = `transform ${duration}ms linear`;
	        bar.style.transform = "scaleY(1)";
	      });
	    });
	  }

	  function reset() {
	    if (!bar || paused) return;

	    bar.style.transition = "none";
	    bar.style.transform = "scaleY(0)";

	    setTimeout(animate, 50);
	  }

	  // Pause/play toggle — WCAG 2.2.2 requires a user-operable stop mechanism
	  // for auto-advancing content independent of the OS reduced-motion
	  // setting, which only sets the *starting* state below.
	  function setPaused(next) {
	    paused = next;
	    if (pauseBtn) {
	      pauseBtn.setAttribute("aria-pressed", String(paused));
	      pauseBtn.setAttribute("aria-label", paused ? "Play slideshow" : "Pause slideshow");
	      pauseBtn.classList.toggle("is-paused", paused);
	    }
	    if (paused) {
	      stop();
	    } else {
	      start();
	    }
	  }

	  if (pauseBtn) {
	    pauseBtn.addEventListener("click", () => setPaused(!paused));
	  }

	  thumbs.forEach((t, i) => {
	    t.addEventListener("click", () => {
	      goTo(i);
	      if (!paused) start();
	    });
	  });

	  goTo(0);
	  // Reduced-motion: start paused rather than never offering autoplay at
	  // all — the button still lets a user opt back into it if they want.
	  setPaused(REDUCED);
	}


// ==========================
// INIT
// ==========================

function runInit() {
    initHeroCards();
    initStatsScroller();
    initPanelSlider();
    initStoriesSlider();
    initMediaSlider();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInit);
} else {
    runInit();
}

})();

// ==========================
// SEARCH MODAL (full-page overlay)
// Open/close + debounced AJAX live search. Default view lists the latest
// newsletters; typing swaps in results from the fh_search handler.
// Config comes from the localized `fhSearch` object (see inc/search.php).
// ==========================
(function () {
    var modal = document.getElementById("search-modal");
    if (!modal) return;

    var input      = modal.querySelector("[data-search-input]");
    var clearBtn   = modal.querySelector("[data-search-clear]");
    var defaultBox = modal.querySelector("[data-search-default]");
    var resultsBox = modal.querySelector("[data-search-results]");
    var listBox    = modal.querySelector("[data-search-list]");
    var heading    = modal.querySelector("[data-search-heading]");
    var emptyMsg   = modal.querySelector("[data-search-empty]");
    var cfg        = window.fhSearch || null;

    var lastFocus     = null;
    var debounce      = null;
    var controller    = null;
    var lastTerm      = null;
    var wasNormalized = false;
    var page          = document.getElementById("page");

    function setExpanded(state) {
        document.querySelectorAll("[data-search-open]").forEach(function (btn) {
            btn.setAttribute("aria-expanded", state ? "true" : "false");
        });
    }

    function getFocusable() {
        return Array.prototype.slice.call(
            modal.querySelectorAll(
                'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
            )
        ).filter(function (el) { return el.offsetParent !== null; });
    }

    function trapFocus(e) {
        if (e.key !== "Tab" || modal.hidden) return;
        var focusable = getFocusable();
        if (!focusable.length) return;
        var first = focusable[0];
        var last  = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    }

    // #search-modal is itself a direct child of #page (a sibling of the
    // header/content/footer, not nested inside them), so inert must be
    // applied to its other siblings individually rather than to #page as
    // a whole — inerting #page would inert the modal too.
    function siblingsExceptModal() {
        if (!page) return [];
        return Array.prototype.slice.call(page.children).filter(function (el) {
            return el !== modal;
        });
    }

    // On touch devices the homepage enables GSAP ScrollTrigger.normalizeScroll,
    // which hijacks wheel/touch globally — the modal's own scroll container never
    // receives them. Suspend it while the modal is open, restore it on close.
    function suspendNormalizeScroll() {
        if (!window.ScrollTrigger || typeof ScrollTrigger.normalizeScroll !== "function") return;
        wasNormalized = !!ScrollTrigger.normalizeScroll();
        if (wasNormalized) { ScrollTrigger.normalizeScroll(false); }
    }

    function restoreNormalizeScroll() {
        if (!window.ScrollTrigger || typeof ScrollTrigger.normalizeScroll !== "function") return;
        if (wasNormalized) { ScrollTrigger.normalizeScroll(true); }
    }

    function openModal() {
        lastFocus = document.activeElement;
        modal.hidden = false;
        document.body.classList.add("search-modal-open");
        suspendNormalizeScroll();
        setExpanded(true);
        siblingsExceptModal().forEach(function (el) { el.setAttribute("inert", ""); });
        document.addEventListener("keydown", trapFocus);
        if (input) { setTimeout(function () { input.focus(); }, 50); }
    }

    function closeModal() {
        modal.hidden = true;
        document.body.classList.remove("search-modal-open");
        restoreNormalizeScroll();
        setExpanded(false);
        siblingsExceptModal().forEach(function (el) { el.removeAttribute("inert"); });
        document.removeEventListener("keydown", trapFocus);
        if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
    }

    // Toggle default (latest newsletters) vs. results view.
    function showDefault() {
        if (defaultBox) defaultBox.hidden = false;
        if (resultsBox) resultsBox.hidden = true;
        if (heading) {
            heading.hidden = true;
            heading.innerHTML = "";
        }
        lastTerm = null;
    }

    function showResults() {
        if (defaultBox) defaultBox.hidden = true;
        if (resultsBox) resultsBox.hidden = false;
    }

    function escapeHtml(str) {
        var div = document.createElement("div");
        div.textContent = str;
        return div.innerHTML;
    }

    function renderResults(term, count, html) {
        if (heading) {
            var label = (cfg && cfg.resultsLabel) || "Results for";
            heading.innerHTML =
                "(" + count + ") " + escapeHtml(label) +
                " <span class=\"search-modal__results-term\">" + escapeHtml(term) + "</span>";
            // Kept hidden until it has content so it is not an empty heading.
            heading.hidden = false;
        }
        if (listBox)  listBox.innerHTML = html || "";
        if (emptyMsg) emptyMsg.hidden = count > 0;
        showResults();
    }

    function runSearch(term) {
        if (!cfg) return;

        if (controller) { controller.abort(); }
        controller = ("AbortController" in window) ? new AbortController() : null;

        var body = new URLSearchParams();
        body.append("action", "fh_search");
        body.append("nonce", cfg.nonce);
        body.append("s", term);

        fetch(cfg.ajaxUrl, {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: body.toString(),
            signal: controller ? controller.signal : undefined
        })
            .then(function (res) { return res.json(); })
            .then(function (response) {
                if (!response || !response.success) return;
                // Ignore a stale response if the field has since changed.
                if (response.data.term !== input.value.trim()) return;
                renderResults(response.data.term, response.data.count, response.data.html);
            })
            .catch(function () { /* aborted or network error — leave view as-is */ });
    }

    function onInput() {
        var term = input.value.trim();
        var minChars = (cfg && cfg.minChars) || 2;

        if (clearBtn) clearBtn.hidden = input.value.length === 0;

        clearTimeout(debounce);

        if (term.length < minChars) {
            if (controller) { controller.abort(); }
            showDefault();
            return;
        }

        if (term === lastTerm) return;
        lastTerm = term;

        debounce = setTimeout(function () { runSearch(term); }, 250);
    }

    if (input) { input.addEventListener("input", onInput); }

    function searchFor(term) {
        term = term.trim();
        if (!input) return;
        input.value = term;
        if (clearBtn) clearBtn.hidden = term.length === 0;
        clearTimeout(debounce);
        if (term.length < ((cfg && cfg.minChars) || 2)) { showDefault(); return; }
        lastTerm = term;
        runSearch(term);
    }

    document.addEventListener("submit", function (e) {
        var form = e.target;
        if (!form.matches || !form.matches('form[role="search"]') || form.matches(".search-page__form")) return;
        var field = form.querySelector('input[name="s"]');
        if (!field) return;
        e.preventDefault();
        if (modal.hidden) { openModal(); }
        searchFor(field.value);
    });

    document.addEventListener("click", function (e) {
        if (e.target.closest("[data-search-open]"))       { e.preventDefault(); openModal(); }
        else if (e.target.closest("[data-search-close]")) { e.preventDefault(); closeModal(); }
        else if (e.target.closest("[data-search-clear]")) {
            e.preventDefault();
            input.value = "";
            if (clearBtn) clearBtn.hidden = true;
            showDefault();
            input.focus();
        }
    });

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !modal.hidden) { closeModal(); }
    });
})();
